var DacConfig = /** @class */ (function () {
    function DacConfig(_environment) {
        this._environment = _environment;
        this._is_dev_environment = false;
        this._enabledFeatures = this._environment.features;
        this._stripePublicKey = this._environment.stripePublicKey;
        this._stripeChargeName = this._environment.stripeChargeName;
        this._applicationTitle = this._environment.applicationTitle;
        this._applicationLogoUrl = this._environment.applicationLogo;
        this._applicationLogoTitle = this._environment.applicationLogoTitle;
        this._api_url = this._environment.apiURL;
        this._supportEmail = this._environment.supportEmail;
        this._supportPhone = this._environment.supportPhone;
        this._reportHeaderImgURL = this._environment.reportHeaderImgURL;
        this._useAddoReports = this._environment.useAddoReports;
        this._cognitoConfig = this._environment.awsCognitoConfig;
        this.window = window;
        var host = this.window.location.host;
        this._take_test_url = this.window.location.protocol + "//" + host + "/login";
        this._skinClasses = this._environment.skinClasses || [];
        this._seamlessMode = sessionStorage.getItem("seamlessMode") === "true";
        if (this._seamlessMode) {
            this.setupSeamlessModeForSession(sessionStorage.getItem('skin'));
        }
        else if (sessionStorage.getItem('skin')) {
            this.setupSkinForSession(sessionStorage.getItem('skin'));
        }
        this._ssoIssuer = sessionStorage.getItem("ssoIssuer");
    }
    DacConfig.prototype.getAWSConfig = function () {
    };
    DacConfig.prototype.setupSkinForSession = function (skin) {
        this._skinClasses = skin.split(" ");
    };
    DacConfig.prototype.is_dev_host = function (host) {
        return host === "discoverandchange.dev" || host === "localhost:8080"
            || host === "localhost:4200"
            || host === 'addo-dev.discoverandchange.com';
    };
    Object.defineProperty(DacConfig.prototype, "take_test_url", {
        get: function () {
            return this._take_test_url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "api_url", {
        get: function () {
            return this._api_url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "is_dev_environment", {
        get: function () {
            return this._is_dev_environment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "stripe_charge_name", {
        get: function () {
            return this._stripeChargeName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "stripe_public_key", {
        get: function () {
            return this._stripePublicKey;
        },
        enumerable: true,
        configurable: true
    });
    DacConfig.prototype.isFeatureEnabled = function (feature) {
        return this._enabledFeatures[feature] === true;
    };
    Object.defineProperty(DacConfig.prototype, "applicationLogoTitle", {
        get: function () {
            return this._applicationLogoTitle;
        },
        set: function (value) {
            this._applicationLogoTitle = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "applicationLogoUrl", {
        get: function () {
            return this._applicationLogoUrl;
        },
        set: function (value) {
            this._applicationLogoUrl = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "applicationTitle", {
        get: function () {
            return this._applicationTitle;
        },
        set: function (value) {
            this._applicationTitle = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "useAddoReports", {
        get: function () {
            return this._useAddoReports;
        },
        set: function (value) {
            this._useAddoReports = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "supportEmail", {
        get: function () {
            return this._supportEmail;
        },
        set: function (value) {
            this._supportEmail = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "supportPhone", {
        get: function () {
            return this._supportPhone;
        },
        set: function (value) {
            this._supportPhone = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "skinClasses", {
        get: function () {
            return this._skinClasses;
        },
        enumerable: true,
        configurable: true
    });
    DacConfig.prototype.replaceSkinClasses = function (skinClasses) {
        if (!skinClasses && skinClasses.length <= 0) {
            throw new Error("Invalid Skin Classes.  Must be an array with length greater than 0");
        }
        this._skinClasses = skinClasses;
        sessionStorage.setItem('skin', skinClasses.join(" "));
    };
    DacConfig.prototype.addSkinClass = function (skinClass) {
        if (skinClass.length <= 0) {
            throw new Error("Skin class must be set ");
        }
        this._skinClasses.push(skinClass);
    };
    Object.defineProperty(DacConfig.prototype, "navBarClass", {
        get: function () {
            return this._environment.navBarClass;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "reportHeaderImgURL", {
        get: function () {
            return this._reportHeaderImgURL;
        },
        set: function (value) {
            this._reportHeaderImgURL = value;
        },
        enumerable: true,
        configurable: true
    });
    DacConfig.prototype.hasPartner = function (partner) {
        return this._environment.partners.indexOf(partner) >= 0;
    };
    DacConfig.prototype.isAssessmentEnabled = function (uid) {
        if (this._environment.disabledAssessments.length == 0) {
            return true;
        }
        else {
            return this._environment.disabledAssessments.indexOf(uid) < 0;
        }
    };
    Object.defineProperty(DacConfig.prototype, "copyrightURL", {
        get: function () {
            return this._environment.copyrightURL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "copyrightTitle", {
        get: function () {
            return this._environment.copyrightTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "seamlessMode", {
        get: function () {
            return this._seamlessMode;
        },
        set: function (v) {
            this._seamlessMode = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DacConfig.prototype, "ssoIssuer", {
        get: function () {
            return this._ssoIssuer;
        },
        set: function (v) {
            this._ssoIssuer = v;
        },
        enumerable: true,
        configurable: true
    });
    DacConfig.prototype.setupSSOIssuerForSession = function (issuer) {
        this._ssoIssuer = issuer;
        sessionStorage.setItem("ssoIssuer", issuer);
    };
    DacConfig.prototype.setupSeamlessModeForSession = function (skin) {
        this.seamlessMode = true;
        sessionStorage.setItem('seamlessMode', "true");
        var skins = ['seamless'];
        if (skin) {
            skins.push(skin);
        }
        this.replaceSkinClasses(skins);
    };
    Object.defineProperty(DacConfig.prototype, "awsCognitoConfig", {
        get: function () {
            return this._cognitoConfig;
        },
        enumerable: true,
        configurable: true
    });
    return DacConfig;
}());
export { DacConfig };
;



// WEBPACK FOOTER //
// ./src/app/shared/services/dac-config.service.ts.pre-build-optimizer.js